module.exports = __webpack_public_path__ + "static/media/come-funziona-lavoratore-03.b4798c9c.png";